/**
 * APP: Taako.
 *
 * Particles from Proton.js
 *
 */

import React from 'react';
import Proton from 'proton-js';

const proton = new Proton();

export class Particles extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ready: false
    };
  }

  componentDidMount() {
    this.createProton();
    this.props.app.ticker.add(this.tick);
    this.setState({
      ready: true
    })
  }

  componentWillUnmount() {
    this.props.app.ticker.remove(this.tick)
  }

  // Loops
  tick = (delta) => {
    proton.update();
  }

  createProton = () => {

    let emitter = new Proton.BehaviourEmitter();

    emitter.damping = 0.0075;
    emitter.rate = new Proton.Rate(20);

    emitter.addInitialize(new Proton.Body('./Assets/Image/08-mote.png', 32));
    emitter.addInitialize(new Proton.Position(new Proton.RectZone(0, 0, window.innerWidth, window.innerHeight)));
    emitter.addInitialize(new Proton.Mass(1), new Proton.Radius(Proton.getSpan(2, 6)));

    let crossZoneBehaviour = new Proton.CrossZone(new Proton.RectZone(-2, -2, window.innerWidth, window.innerHeight), 'cross');
    emitter.addBehaviour(crossZoneBehaviour);
    emitter.addBehaviour(new Proton.Scale(Proton.getSpan(0.3, 0.8)));
    emitter.addBehaviour(new Proton.Alpha(0.02));
    emitter.addBehaviour(new Proton.RandomDrift(10, 10, .2));

    emitter.addBehaviour({
      initialize: function(particle) {
        particle.tha = Math.random() * Math.PI;
        particle.thaSpeed = 0.015 * Math.random();
      },
      applyBehaviour: function(particle) {
        particle.tha += particle.thaSpeed;
        particle.alpha = Math.abs(Math.cos(particle.tha)) + 0.5;
      }
    });

    emitter.emit('once');

    proton.addEmitter(emitter);
    proton.addRenderer(new Proton.PixiRenderer(this.props.app.stage));
  }

  render() {
    return (
      null
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layers/Particles.js